export default __webpack_public_path__ + "static/media/photo_gallery_9.89e55c78.png";